import React, { useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'

// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';

/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import AutoCompleteSelect from 'components/Common/ElementInForm/AutoCompleteSelect';
import { ColorCMM, ColorGSM, ColorNGR, ColorNGV } from '../../FixColor';
am4core.addLicense("CH208466903");


const StackedColumnChart = (props) => {
    const { sBA, data, ImgChart } = props

    const [DataRender, setDataRender] = useState([] as any);
    const [optionYear, setOptionYear] = useState([] as any);

    const schema = yup.object().shape({
        oTypeDisplay: yupFormSchemas.object('ปี', { required: false }),
    });

    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError"
    })

    useEffect(() => {
        if (data != null) {

            setOptionYear(data.option || []);

            if (data.option.length > 0) {
                form.setValue("oTypeDisplay", data.option[0])
                renderData(data.option[0].value)
            }

        }
    }, [data])

    const renderData = (value) => {
        if (value != null) {

            var oGraph = data.data.filter(item => item.year === value);

            if (oGraph != null && oGraph.length > 0) {
                var dataGraph = oGraph[0];
                onRenderGraph(dataGraph)
            }
        }
    }

    const onRenderGraph = (detail) => {

        let chart = am4core.create("StackedColumnChart", am4charts.XYChart);

        let sFormFilter = form.getValues("oTypeDisplay")
        let Value = sFormFilter != null ? sFormFilter.label : "";

        let title = chart.titles.create();
        title.text = Value != "" ? "ใบงานที่ยังไม่ได้รับการประเมิน ("+Value+")" : "ใบงานที่ยังไม่ได้รับการประเมิน";
        title.fontSize = 16;
        title.marginBottom = 10;
        title.align = "center";
        title.fontWeight = '400';

        var colorSet = new am4core.ColorSet();
        colorSet.list = [ColorCMM(), ColorGSM(), ColorNGR(), ColorNGV()].map(color => {
            return am4core.color(color);
        });
        chart.colors = colorSet;

        chart.legend = new am4charts.Legend();
        chart.legend.position = "bottom";

        // // Create axes
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "Month";
        categoryAxis.title.text = "เดือน";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 20;
        categoryAxis.renderer.cellStartLocation = 0.1;
        categoryAxis.renderer.cellEndLocation = 0.9;
        categoryAxis.renderer.grid.template.opacity = 0;
        categoryAxis.renderer.labels.template.rotation = -45;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;
        valueAxis.title.text = "จำนวนใบงานที่ยังไม่ได้รับการประเมิน";

        chart.data = detail.data;

        // Create series

        detail.BA.forEach(type => {
            var series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueY = type;
            series.dataFields.categoryX = "Month";
            series.stacked = true;
            series.name = type;
            series.columns.template.tooltipText = type + ": [bold]{valueY}[/]";
            series.columns.template.width = am4core.percent(95);

            let labelBullet = series.bullets.push(new am4charts.LabelBullet());
            labelBullet.locationY = 0.5;
            labelBullet.label.text = "{valueY}";
            labelBullet.label.fontSize = "8pt";
            labelBullet.label.fill = am4core.color("#fff");
        });

        setTimeout(() => {
            chart.exporting.getImage("png").then((data) => {
                let idDiv = 7;
                let obj = {} as any;
                let idx7 = ImgChart.findIndex(f => f.idDiv == idDiv);
                if (idx7 !== -1) {
                    ImgChart[idx7].imgBase64 = data;
                }
                else {

                    obj = {
                        id: 1,
                        nOrder: 1,
                        sDesc: "Div 7 stack",
                        sName: "ใบงานที่ยังไม่ได้รับการประเมิน",
                        idDiv: 7,
                        imgBase64: data
                    }
                    props.exportImg && props.exportImg(obj);
                }
            });
        }, 2000);
    }

    return (
        <>
            <div className='div-border'>
                <Grid container spacing={2} direction="row" justifyContent="end" alignItems="center">
                    <Grid item xs={12} sm={8} >
                        <Typography style={{ fontWeight: 500 }}>กลุ่มตลาด: {sBA}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormProvider {...form}>
                            <AutoCompleteSelect
                                name="oTypeDisplay"
                                options={optionYear || []}
                                label={''}
                                onChange={(e) => renderData(e.value)}
                                required={false}
                                disableClearable={true}
                                IsRadius={true}
                            />
                        </FormProvider>
                    </Grid>
                    <Grid item xs={12} >
                        <div id='SatisFactiondiv7' style={{ padding: '8px' }}>
                            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="start" >
                                <Grid item xs={12}>
                                    <div id="StackedColumnChart" style={{ width: "100%", minHeight: "400px" }}></div>
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </>
    )
}

export default StackedColumnChart